import { c as _c } from "react/compiler-runtime";
interface CurvedUnderlineProps {
  hoverLinkClasses?: string; // For customizing the hover effect on the link
  hoverUnderlinePathClasses?: string; // For customizing the path hover effect
  color?: string; // Optional: To customize the color of the underline
}
const CurvedUnderline: React.FC<CurvedUnderlineProps> = t0 => {
  const $ = _c(5);
  const {
    hoverLinkClasses: t1,
    hoverUnderlinePathClasses: t2,
    color: t3
  } = t0;
  const hoverLinkClasses = t1 === undefined ? "" : t1;
  const hoverUnderlinePathClasses = t2 === undefined ? "origin-left scale-x-0 transition-transform duration-500 ease-[cubic-bezier(0.4,0,0.2,1)] group-hover:scale-x-100" : t2;
  const color = t3 === undefined ? "#00698F" : t3;
  const t4 = `absolute bottom-[-4px] left-0 h-[6px] w-full stroke-current text-[${color}] ${hoverLinkClasses}`;
  let t5;
  if ($[0] !== hoverUnderlinePathClasses) {
    t5 = <path d="M1 3 C20 1, 80 1, 99 3" fill="transparent" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" className={hoverUnderlinePathClasses} />;
    $[0] = hoverUnderlinePathClasses;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  let t6;
  if ($[2] !== t4 || $[3] !== t5) {
    t6 = <svg className={t4} viewBox="0 0 100 6" preserveAspectRatio="none">{t5}</svg>;
    $[2] = t4;
    $[3] = t5;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  return t6;
};
export default CurvedUnderline;